import { useState, useEffect } from 'react';

export default function useDelay({ begin = true, duration = 100 }) {
  const [triggered, setTriggered] = useState(false);

  useEffect(() => {
    let timeout;

    if (begin) {
      timeout = setTimeout(() => {
        setTriggered(true);
      }, duration);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [begin, duration]);

  return triggered;
}
